/**
 * 用于包装事件的一个小类
 */
export class FuncPack {
    constructor(func, context) {
        this.func = func;
        this.context = context;
    }
}
/**
 * 用于事件管理
 */
export class Emitter {
    constructor() {
        this._messageTable = new Map();
    }
    /**
     * 开始监听项
     * @param eventType 监听类型
     * @param handler 监听函数
     * @param context 监听上下文
     */
    addObserver(eventType, handler, context) {
        let list = this._messageTable.get(eventType);
        if (!list) {
            list = [];
            this._messageTable.set(eventType, list);
        }
        if (!this.hasObserver(eventType, handler)) {
            list.push(new FuncPack(handler, context));
        }
    }
    /**
     * 移除监听项
     * @param eventType 事件类型
     * @param handler 事件函数
     */
    removeObserver(eventType, handler) {
        let messageData = this._messageTable.get(eventType);
        if (messageData) {
            let index = messageData.findIndex(data => data.func == handler);
            if (index != -1)
                messageData.splice(index, 1);
        }
    }
    /**
     * 触发该事件
     * @param eventType 事件类型
     * @param data 事件数据
     */
    emit(eventType, ...data) {
        let list = this._messageTable.get(eventType);
        if (list) {
            for (let observer of list) {
                observer.func.call(observer.context, ...data);
            }
        }
    }
    /**
     * 判断是否存在该类型的观察者
     * @param eventType 事件类型
     * @param handler 事件函数
     */
    hasObserver(eventType, handler) {
        let list = this._messageTable.get(eventType);
        return list ? list.some(observer => observer.func === handler) : false;
    }
}
//# sourceMappingURL=Emitter.js.map